type FontSize = [
  string,
  { lineHeight: string; fontWeight: string; letterSpacing?: string },
]

const HEADING = "var(--line-height-heading)"
const TIGHT = "var(--line-height-tight)"
const NORMAL = "var(--line-height-normal)"
const NONE = "var(--line-height-none)"

export const FONT_SIZES = {
  h1: ["var(--font-size-h1)", { lineHeight: HEADING, fontWeight: "600" }],
  h2: ["var(--font-size-h2)", { lineHeight: HEADING, fontWeight: "600" }],
  h3: ["var(--font-size-h3)", { lineHeight: TIGHT, fontWeight: "500" }],
  h4: ["var(--font-size-h4)", { lineHeight: TIGHT, fontWeight: "500" }],
  "large-bold": [
    "var(--font-size-large)",
    { lineHeight: TIGHT, fontWeight: "700" },
  ],
  "large-medium": [
    "var(--font-size-large)",
    { lineHeight: TIGHT, fontWeight: "500" },
  ],
  "body-bold": [
    "var(--font-size-body)",
    { lineHeight: NORMAL, fontWeight: "700" },
  ],
  "body-semibold": [
    "var(--font-size-body)",
    { lineHeight: NORMAL, fontWeight: "600" },
  ],
  "body-medium": [
    "var(--font-size-body)",
    { lineHeight: NORMAL, fontWeight: "500" },
  ],
  "body-regular": [
    "var(--font-size-body)",
    { lineHeight: NORMAL, fontWeight: "400" },
  ],
  "small-bold": [
    "var(--font-size-small)",
    { lineHeight: TIGHT, fontWeight: "700" },
  ],
  "small-semibold": [
    "var(--font-size-small)",
    { lineHeight: TIGHT, fontWeight: "600" },
  ],
  "small-medium": [
    "var(--font-size-small)",
    { lineHeight: TIGHT, fontWeight: "500" },
  ],
  "small-regular": [
    "var(--font-size-small)",
    { lineHeight: TIGHT, fontWeight: "400" },
  ],
  "extra-small-semibold": [
    "var(--font-size-extra-small)",
    { lineHeight: TIGHT, fontWeight: "600" },
  ],
  "extra-small-medium": [
    "var(--font-size-extra-small)",
    { lineHeight: TIGHT, fontWeight: "500" },
  ],
  "extra-small-regular": [
    "var(--font-size-extra-small)",
    { lineHeight: TIGHT, fontWeight: "400" },
  ],
  overline: [
    "var(--font-size-extra-small)",
    { lineHeight: TIGHT, fontWeight: "600", letterSpacing: "0.04em" },
  ],
  "tiny-semibold": [
    "var(--font-size-tiny)",
    { lineHeight: TIGHT, fontWeight: "600" },
  ],
  "tiny-medium": [
    "var(--font-size-tiny)",
    { lineHeight: TIGHT, fontWeight: "500" },
  ],
  "tiny-regular": [
    "var(--font-size-tiny)",
    { lineHeight: TIGHT, fontWeight: "400" },
  ],
  "display-h1": [
    "var(--font-size-display-h1)",
    { lineHeight: NONE, fontWeight: "500" },
  ],
  "display-h2": [
    "var(--font-size-display-h2)",
    { lineHeight: NONE, fontWeight: "500" },
  ],
} satisfies Record<string, FontSize>

export const FONT_SIZE_CLASSES = Object.keys(FONT_SIZES).map(
  (name) => `text-${name}`,
)
